<template>
  <div id="component">
    <rico id="rico" ref="rico" />
    <!-- <button @click="right">right</button>
    <button @click="kick">kick</button>
    <button @click="blink">blink</button>
    <button @click="left">left</button>-->

    <!-- <emailForm /> -->
  </div>
</template>

<script>
import rico from "./rico.vue";
import emailForm from "./emailForm.vue";

export default {
  name: 'hero',
  components: {
    rico,
    emailForm
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods: {
    left: function () {
      this.$refs.rico.lookLeft();
    },
    right: function () {
      this.$refs.rico.lookRight();
    },
    kick: function () {
      this.$refs.rico.kick();
    },
    blink: function () {
      this.$refs.rico.blink();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ui-icon-loading {
  display: none;
}

#component {
  height: 100%;
  width: 100%;
  background-image: linear-gradient(white, white, white, #ddd, #ddd, #ddd);
}

.center {
  margin: 0;
  position: absolute;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.vcenter {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

#rico {
  margin: 0;
  position: absolute;
  width: 320px;
  height: 360px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@media screen and (max-width: 500px) {
  #rico {
    width: 240px;
    height: 270px;
    top: 45%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hero.vue